<template>
  <div>
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('application_edit')" >
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-apps</v-icon>{{ item['name'] }}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-application-show">
      <v-img
        class = "ma-2"
        max-height="250"
        max-width="250"
        lazy-src="@/assets/imagenotfound.png"
        :key="componentKey"
        :src="imageurlItem"
      >
        <ImageForm
          ref="updateForm"
          :item="item"
          v-if="userHasAccess('application_edit')"
        />
          <v-btn
            color="secondary"
            small
            absolute
            bottom
            right
            @click="downloadItem()"
          >
            <v-icon>mdi-download-circle</v-icon>
          </v-btn>
      </v-img>
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('global.name') }}</strong></td>
              <td>
                                    {{ item['name'] }}
              </td>
              <td><strong>{{ $t('app.url') }}</strong></td>
              <td>
                                    {{ item['url'] }}
              </td>
            </tr>

          </tbody>
        </template>
      </v-simple-table>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import FileMixin from '../../mixins/FileMixin';
import Toolbar from '../../components/Toolbar';
import ImageForm from '../../components/ImageForm.vue';

const servicePrefix = 'Application';

export default {
  name: 'ApplicationShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar,
      ImageForm
  },
  mixins: [ShowMixin,AccessMixin,FileMixin],
  computed: {
    ...mapFields('application', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('application', ['find'])
  },
  methods: {
    ...mapActions('application', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    })
  }
};
</script>
